import loginReducer from "./loginReducer";

const rootReducer = {
  login: loginReducer,
};
export default rootReducer;
